/**
 * Created by Misa.Qarahqani on 8/23/2019.
 */
import * as React from "react";
import {connect} from "react-redux";
import {Col, Form, Input, Row} from 'antd';
import {FormattedMessage} from "react-intl";
import ModalForm from "@hocs/ModalForm";
import {User} from "@models/user";
import {changePasswordRequest as updateRequest} from "@actions/auth";
import {ApplicationState} from "@reducers/index";

interface PropsFromState {
    loading: boolean;
    errors?: string;
    form: any;
    user?: User,
}

interface PropsFromDispatch {
    updateRequest: typeof updateRequest;
}

type ChangePasswordFormAllProps = PropsFromState & PropsFromDispatch


interface ChangePasswordFormStateShape extends User {
    visible: boolean;
    id: string;
    confirmDirty: boolean;
    user_password: string;
    new_password: string;
    confirm_password: string;
}


class ChangePassword extends React.Component<ChangePasswordFormAllProps, ChangePasswordFormStateShape> {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            id: props.id,
            confirmDirty: false,
            user_password: props.user_password,
            new_password: props.new_password,
            confirm_password: props.confirm_password
        };
    }

    getValues = () => {
        let returnValues: any = null;
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                returnValues = {
                    old_password: values.user_password,
                    new_password: values.new_password,
                    id: this.state.id
                };
            }
        });
        return {
            payload: returnValues,
            id: this.state.id,
        };
    };
    compareToFirstPassword = (rule, value, callback) => {
        const {form} = this.props;
        if (value && value !== form.getFieldValue('new_password')) {
            callback('عدم تطابق رمزها!');
        } else {
            callback();
        }
    };

    validateToNextPassword = (rule, value, callback) => {
        const {form} = this.props;
        if (value && this.state.confirmDirty) {
            form.validateFields(['confirm_password'], {force: true});
        }
        callback();
    };
    handleConfirmBlur = e => {
        const {value} = e.target;
        this.setState({confirmDirty: this.state.confirmDirty || !!value});
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        return (
            <Form>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            label={<FormattedMessage id="app.current_password" defaultMessage={`Current Password`}/>}>
                            {getFieldDecorator("user_password", {
                                initialValue: this.state.user_password,
                                rules: [{
                                    whitespace: true,
                                    required: true,
                                    message: <FormattedMessage id="app.password_is_required"
                                                               defaultMessage={`Password is required`}/>
                                }, {
                                    min: 8,
                                    message: <FormattedMessage id="app.min_length_password"
                                                               defaultMessage={`Password must be have at least 8 character`}/>
                                }]
                            })(<Input.Password/>)}
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Form.Item label={<FormattedMessage id="app.new_password" defaultMessage={`New Password`}/>}
                                   hasFeedback>
                            {getFieldDecorator('new_password', {
                                rules: [
                                    {
                                        whitespace: true,
                                        required: true,
                                        message: <FormattedMessage id="app.password_is_required"
                                                                   defaultMessage={`Password is required`}/>,
                                    },
                                    {
                                        min: 8,
                                        message: <FormattedMessage id="app.min_length_password"
                                                                   defaultMessage={`Password must be have at least 8 character`}/>
                                    },
                                    {
                                        validator: this.validateToNextPassword,
                                    },
                                ],
                            })(<Input.Password/>)}
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            label={<FormattedMessage id="app.confirm_password" defaultMessage={`Confirm Password`}/>}
                            hasFeedback>
                            {getFieldDecorator('confirm_password', {
                                rules: [
                                    {
                                        whitespace: true,
                                        required: true,
                                        message: <FormattedMessage id="app.confirm_ur_password"
                                                                   defaultMessage={`Password is required`}/>
                                    },
                                    , {
                                        min: 8,
                                        message: <FormattedMessage id="app.min_length_password"
                                                                   defaultMessage={`Password must be have at least 8 character`}/>
                                    },
                                    {
                                        validator: this.compareToFirstPassword,
                                    },
                                ],
                            })(<Input.Password onBlur={this.handleConfirmBlur}/>)}
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        );
    }
}

const mapStateToProps = ({changePassword}: ApplicationState, ownProps) => {//
    return {
        loading: changePassword && changePassword.loading,
        errors: changePassword && changePassword.errors
    }
};

const mapDispatchToProps = {
    updateRequest
};
const WrappedChangePasswordForm = Form.create({name: "change-password-form"})(ChangePassword);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ModalForm(WrappedChangePasswordForm));


